import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '热门分类',
    links: [
      { label: '明星八卦', path: '/category/star-gossip' },
      { label: '网红翻车', path: '/category/influencer-fails' },
      { label: '擦边吃瓜', path: '/category/edgy-content' },
      { label: '经典大瓜', path: '/category/classic' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about' },
      { label: '爆料大赛', path: '/about' },
      { label: '用户口碑', path: '/about' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { label: '八卦有理', path: '/category/star-gossip' },
      { label: '吃瓜无罪', path: '/category/influencer-fails' },
      { label: '黑料大全', path: '/category/classic' },
      { label: '全民吃瓜', path: '/' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-foreground-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          {/* Top Section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
            {/* Brand Column */}
            <div className="lg:col-span-2">
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-2xl md:text-3xl text-accent-500">吃瓜网</span>
              </Link>
              <p className="text-foreground-300 text-sm leading-relaxed max-w-sm mb-6">
                🔥吃瓜网官网 — 明星八卦黑料大全、网红翻车实锤证据、擦边内容聚合平台。八卦有理，吃瓜无罪，全民参与爆料大赛，抢占吃瓜第一排！
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800/50 text-foreground-300 hover:bg-primary-500 hover:text-white transition-all duration-300 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800/50 text-foreground-300 hover:bg-primary-500 hover:text-white transition-all duration-300 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800/50 text-foreground-300 hover:bg-primary-500 hover:text-white transition-all duration-300 cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800/50 text-foreground-300 hover:bg-primary-500 hover:text-white transition-all duration-300 cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>

            {/* Link Columns */}
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-base text-foreground-100 mb-4">{col.title}</h4>
                <ul className="space-y-3">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-300 hover:text-accent-500 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Divider */}
          <div className="mt-12 pt-8 border-t border-foreground-800/30 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 吃瓜网官网. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">用户协议</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}